<script setup lang="ts">
/** The lime square with a `(`, and the lowercase wordmark (§11a). */
withDefaults(defineProps<{ wordmark?: boolean; size?: number }>(), {
  wordmark: true,
  size: 28,
});
</script>

<template>
  <span class="inline-flex items-center gap-2 font-display text-lg font-bold tracking-tight">
    <span
      class="flex items-center justify-center rounded-lg bg-sulje"
      :style="{ width: `${size}px`, height: `${size}px` }"
      aria-hidden="true"
    >
      <svg :width="size * 0.6" :height="size * 0.6" viewBox="0 0 24 24" fill="none">
        <path
          d="M15 3.5C9.5 7 9.5 17 15 20.5"
          stroke="#0a0a0a"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
    </span>
    <span v-if="wordmark">sulje</span>
    <span v-else class="sr-only">Sulje</span>
  </span>
</template>
